import React from 'react';
import { Grid, Typography, useTheme } from '@mui/material';
import { formatDateForChat } from '../../../utils/dateUtils';

interface IDateProps {
  messageDate: string;
}

function Date({ messageDate }: IDateProps) {
  const theme = useTheme();

  return (
    <Grid container justifyContent="center">
      <Grid
        p="4px 16px"
        borderRadius="5px"
        border="0.5px solid rgba(255, 221, 200, 0.50)"
        boxShadow={theme.borderStyles.cardBorders}
      >
        <Typography color="primary" variant="tinyTexts">
          {formatDateForChat(messageDate)}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default Date;
